/* eslint-disable @typescript-eslint/ban-types */
import { gql, LazyQueryHookOptions, QueryTuple } from '@apollo/client';

import { useAPILazyQuery } from 'Api/handler';

export type AskContactResponse = {
  id: number;
};

export type AskContactVariables = {
  accountId: number;
};

export const useAskContact = (
  options?: LazyQueryHookOptions<AskContactResponse, AskContactVariables>,
): QueryTuple<AskContactResponse, AskContactVariables> => {
  return useAPILazyQuery(ASK_CONTACT, options);
};

export const ASK_CONTACT = gql`
  query AskContact($accountId: Float) {
    askContact(accountId: $accountId) {
      id
    }
  }
`;
